module.exports = __webpack_public_path__ + "img/course-item-new-active-bg.3825f3e9.png";